export function processProgramLearningOutcomes(module, mapContainer) {
  let outcomesTitle = mapContainer.find('h3.acalog-program-core-name:contains("Program Learning Outcomes")').first();

  if (!outcomesTitle.length) {
    return;
  }

  let descriptionContainer = outcomesTitle.next(".acalog-program-core-description");

  if (!descriptionContainer.length) {
    return;
  }
  let outcomesDataContainer = module.find(".js-learningOutcomesData");
  outcomesDataContainer.html(descriptionContainer.html());
}